import get from 'lodash/get';
import { AppParams } from '../models/configuration/AppParams';
import { Formatter } from '../models/configuration/Format';
import formatter from '../utils/formatter';
import ReplacePlaceholdersOptions from '../models/utils/ReplacePlaceholdersOptions';

// This function replaces placeholders enclosed in curley braces with the actual value. For example:
// "http://www.clientwebsitesite.com/fundexplorer/{isin}" -> "http://www.clientwebsitesite.com/fundexplorer/GB1234567890"

export const replacePlaceholders = (
    replaceOptions: ReplacePlaceholdersOptions
) => {
    const {
        text,
        values,
        valueKey,
        format,
        dataStore,
        appParams,
    } = replaceOptions;
    if (text) {
        const { type, locale, currency, options } = format || ({} as Formatter);
        const parsedText = text.replace(/({)[^{]+(})/g, match => {
            const key = match.replace('{', '').replace('}', '');

            if (appParams && key.substring(0, 4).toLowerCase() === 'app:') {
                return appParams[key.substring(4, key.length)];
            }

            const value = get(values, `${key}${valueKey ? valueKey : ''}`, '');

            return format
                ? formatter({
                      type,
                      locale,
                      currency,
                      options,
                      value,
                      dataStore,
                  })
                : value;
        });

        return parsedText;
    }
};

export const replacePropertyPlaceholders = (
    values: {},
    text: string,
    appParams?: AppParams
) => {
    return replacePlaceholders({
        values,
        text,
        appParams,
        valueKey: '.value',
    });
};



// WEBPACK FOOTER //
// ./src/utils/replacePlaceholders.ts